import request from '../config/axios-config';

export function getPapersForUser(page, query) {
    return (
        request({
            method: 'get',
            url: '/paper/' + page + query,
        }))
}

export function getPapersForSigning() {
    return (
        request({
            method: 'get',
            url: '/paper/for-signing'
        }))
}

export function approve(paperId, approve, motivation, deletedArticlesIds, articles) {
    return (
        request({
            method: 'post',
            url: '/paper/approve',
            data: {
                paperId: paperId,
                approve: approve,
                motivation: motivation,
                deletedArticlesIds: deletedArticlesIds,
                articles: approve ? articles : null
            }
        }))
}

export function addPaper(body) {
    return (
        request({
            url: "/paper/add",
            method: 'post',
            data: body
        }))
}